import React, { useEffect, useState } from 'react';
import YouTube from 'react-youtube';
import isMobile from '~/utils/new-is-mobile';

import IntroBackground from './asset/intro-background.png';
import MissionText_1 from './asset/mission-text_1.png';
import MissionImg_1 from './asset/mission-img_1.png';
import MissionText_2 from './asset/mission-text_2.png';
import MissionImg_2 from './asset/mission-img_2.png';
import PcApplyBtn from './asset/pc_apply_btn.png';
import QRforRelease from './asset/QRforRelease.png';

import { 
  BGWrap, 
  YoutubeWrap, 
  CodeBGWrap, 
  ButtonBGWrap,
  ButtonWrap,
  Button,
} from './styled';

const TvcPcComponent = () => {
  const [deviceType, setDeviceType] = useState('')

  useEffect(()=>{
    setDeviceType(isMobile() ? "mobile" : "pc");
  },[])
  
  const buttonRender = () => {
    if(deviceType === 'mobile') {
      return (
        <ButtonBGWrap>
          <ButtonWrap as={"a"} href={"https://dabang.app.link/fKW8li6vjyb"}>
            <Button  width={590} height={125} imgUrl={PcApplyBtn} />
          </ButtonWrap>
        </ButtonBGWrap>
      );

    } else if ('pc') {
      return (
        <CodeBGWrap imgUrl={QRforRelease}/>
      );
      
    } else {
      return null;
    }
  }

  return (
    <>
      <BGWrap width={710} height={1134} imgUrl={IntroBackground} >
        <YoutubeWrap>
          <YouTube videoId="wqUtWSGc-64" />
        </YoutubeWrap>
      </BGWrap>

      <BGWrap width={710} height={302} imgUrl={MissionText_1} />

      <BGWrap width={710} height={580} imgUrl={MissionImg_1} />
      
      <BGWrap width={710} height={302} imgUrl={MissionText_2} />
      
      <BGWrap width={710} height={450} imgUrl={MissionImg_2} />

      {buttonRender()}
    </>
  );
};

export default TvcPcComponent;
